
import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Calendar, Check } from "lucide-react";

interface BlogPublishSettingsProps {
  publishDate: string;
  isPublished: boolean;
  onPublishDateChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onIsPublishedChange: (checked: boolean) => void;
  disabled: boolean;
}

export const BlogPublishSettings = ({
  publishDate,
  isPublished,
  onPublishDateChange,
  onIsPublishedChange,
  disabled
}: BlogPublishSettingsProps) => {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">Publish Settings</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex flex-col space-y-1.5">
          <Label htmlFor="publishDate" className="flex items-center gap-2">
            <Calendar size={16} />
            <span>Publish Date</span>
          </Label>
          <Input
            type="date"
            id="publishDate"
            value={publishDate}
            onChange={onPublishDateChange}
            disabled={disabled}
          />
        </div>

        <div className="flex items-center justify-between space-x-2 pt-2">
          <Label htmlFor="isPublished" className="flex items-center gap-2 cursor-pointer">
            <Check size={16} />
            <span>Published</span>
          </Label>
          <Switch
            id="isPublished"
            checked={isPublished}
            onCheckedChange={onIsPublishedChange}
            disabled={disabled}
          />
        </div>
      </CardContent>
    </Card>
  );
};
